import React, { useContext } from 'react';
import { getPath } from '@express-labs/raven-tools';


import AccountPanel from './AccountPanel';
import { sanitizeTierName } from '../MyInsiderIDModal/index';
import { HeaderDynamicContext } from '../../../../../../contexts/HeaderDynamicData/HeaderDynamicData';
import getFromStorage from '../../../../../../helpers/storage/storage';
import { LOYALTY_NEW_TIERS_POINTS, TIER_STATIC_CONFIGS, DEFAULT_TIER } from '../../../../../../constants';

function AccountPanelVM(props) {
  const { customer, loyaltyRewards } = useContext(HeaderDynamicContext);
  const loyaltyWarmStateData = getFromStorage('loyaltyWarmStateData', {});
  const tierName = getPath(loyaltyWarmStateData, 'tierName', 'insider');
  const sanitizedTierName = sanitizeTierName(tierName);
  const loyaltyId = loyaltyWarmStateData.loyaltyNumber || '';
  const customerData = { loyaltyId, ...customer };
  // Data for tiers
  const tierConfig = TIER_STATIC_CONFIGS[sanitizedTierName] || DEFAULT_TIER;
  const tierIcon = getPath(tierConfig, 'tierMobileIcon', '');
  const nextTierName = getPath(tierConfig, 'nextTier.name', '');
  const pointsForNextTier = LOYALTY_NEW_TIERS_POINTS[sanitizedTierName] || 2500;
  const hasNextTier = sanitizedTierName !== 'vip' && sanitizedTierName !== 'alist';
  const pointsToRetainTier = getPath(loyaltyWarmStateData, 'pointsToRetainCurrentTier', null);
  const tierExpirationDate = getPath(loyaltyWarmStateData, 'tierExpirationDate', '');
  const keepStatus = sanitizedTierName !== 'vip';
  const memberWalletEnhancement = window?.FLAGS?.MemberWalletEnhancement || false;

  return (
    <AccountPanel
      customerData={customerData}
      loyaltyRewards={loyaltyRewards}
      memberWalletEnhancement={memberWalletEnhancement}
      pointsForNextTier={pointsForNextTier}
      tierIcon={tierIcon}
      hasNextTier={hasNextTier}
      nextTierName={nextTierName}
      pointsToRetainTier={pointsToRetainTier}
      tierExpirationDate={tierExpirationDate}
      keepStatus={keepStatus}
      {...props}
    />
  );
}

export default React.memo(AccountPanelVM);
